import { slideIn, slideOut } from '../animations';

export default function introductionStep(presentation) {
  // NOTE: Buttons on this step are handled in become.js

  const { elements } = presentation;

  const {
    introduction,
    logoLetters,
    logoOImage,
    logoAImage,
    logoWImage,
    logoOSmall,
    logoLettersBoxes,
    introductionButtonImage,
  } = elements;

  const images = [logoOImage, logoAImage, logoWImage];
  const placeBoxes = introductionButtonImage.map(el =>
    el.getBoundingClientRect(),
  );

  presentation.addStep({
    id: 'introduction',
    default: {
      enter({ timeline, label }) {
        slideIn(introduction)({ timeline, label });
        timeline.set(logoOSmall, { opacity: 1 }, label);
        timeline.set(
          images,
          { className: '+=has-animation is-visible' },
          `${label}+=1`,
        );

        logoLetters.forEach((logo, index) => {
          const placeBox = placeBoxes[index];
          const logoBox = logoLettersBoxes[index];
          const widthScale = placeBox.width / logoBox.width;
          const heightScale = placeBox.height / logoBox.height;

          let paddingLeft = 0;
          if (heightScale < widthScale) {
            paddingLeft = (placeBox.width - logoBox.width * heightScale) / 2;
          }

          timeline.to(
            logo,
            1,
            {
              x: placeBox.left + paddingLeft,
              y: placeBox.top,
              scale: Math.min(widthScale, heightScale),
            },
            label,
          );
        });
      },
      leave({ timeline, label }) {
        slideOut(introduction)({ timeline, label });
        timeline.set(images, { className: '+=no-animation' }, label);
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/steps/introduction.js